// Oversized figures extend above their tile (see .sized-overflow-frame). Give each row of a figure grid
// (including the homepage's row of random figures) enough extra headroom for its tallest figure, so tall
// figures don't cover what's above. Sideways overflow is left alone: wide figures still overlap their neighbors.
(function() {
  function addRowHeadroom() {
    $('ul.figures-cards, .random-figures').each(function() {
      var items = $(this).children();
      items.css('padding-top', '');

      var headroomByRow = {};
      items.each(function() {
        var item = $(this);
        var frame = item.find('.sized-overflow-frame');
        var headroom = frame.length ? frame.data('overflowTop') * frame.height() : 0;
        var row = Math.round(item.position().top);
        item.data('row', row);
        headroomByRow[row] = Math.max(headroomByRow[row] || 0, headroom);
      });

      items.each(function() {
        var item = $(this);
        var headroom = headroomByRow[item.data('row')];
        if (headroom > 0) {
          item.css('padding-top', parseFloat(item.css('padding-top')) + headroom + 'px');
        }
      });
    });
  }

  $(addRowHeadroom);
  $(window).on('resize', _.debounce(addRowHeadroom, 150));
})();
